export default __webpack_public_path__ + "static/media/delete-svgrepo-com.c8040327.svg";